import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-off-vpn',
  template: 
  `<div class="off-vpn-container">
    <h2>Unable to reach the Lytx Device Control Center.</h2><br><br>

    <h3>VPN connection required. Please check your VPN connection, or remote Log in to Cisco AnyConnect VPN.<br><br>
    
    lytxvpn.drivecam.com</h3><br><br>
    
    <h4>Please contact Lytx IT Help if you do not have Cisco AnyConnect. Note: VPN will not work while on Lytx Office Wi-Fi network.</h4><br><br>
    
    <b>If the connection problem persists, please notify one of the following:</b><br>
    
    <b>Slack channel</b><br>
    #device-platform-access-controlcenter<br><br>
    
    <b>Lytx Technical Support</b><br>
    techsupport-tier3@lytx.com<br>
    +1 (866) 910-0403 <br>
    https://www.lytx.com/contact-us/support<br>

    <button (click)="retry()">Retry Connection</button>
    </div>`,
  styles: [".off-vpn-container {padding: 50px}"]
})
export class OffVpnComponent {

  constructor(private router: Router) { }

  retry() {
    this.router.navigateByUrl('');
  }

}
